// declare a fonction named showPastries
function showPastries(id,num,min,max) {
    var pastry = document.querySelector('[data-id="' + id + '"]');

    var arrowLeft = pastry.querySelector('.arrow-left');
    var arrowRight = pastry.querySelector('.arrow-right');

    var arrowLeftMobile = pastry.querySelector('.arrow-left-mobile');
    var arrowRightMobile = pastry.querySelector('.arrow-right-mobile');
    // on enlève la classe hidden   
    pastry.classList.remove('hidden');

    // en fonction du max et du min on remove la class hidden des arrows pour les afficher 

    if (num == min) {
        arrowRight.classList.remove('hidden');
        arrowRightMobile.classList.remove('hidden');
        //justify content flex end
        document.querySelector('.arrows').style.justifyContent = 'flex-end';

        // arrowRightMobile.style.position = 'absolute';
        // arrowRightMobile.style.right = '8%';
    }
    else if (num == max) {
            arrowLeft.classList.remove('hidden');
            arrowLeftMobile.classList.remove('hidden');

            //justify content flex start
            document.querySelector('.arrows').style.justifyContent = 'flex-start';
            // arrowLeftMobile.style.position = 'absolute';
            // arrowLeftMobile.style.left = "8%";
    }
    else {
        arrowLeft.classList.remove('hidden');
        arrowRight.classList.remove('hidden');
        arrowLeftMobile.classList.remove('hidden');
        arrowRightMobile.classList.remove('hidden');
    }


    var filter = document.querySelector('.filter');
    filter.classList.remove('hidden');
    // disable vertical scroll
    // document.body.style.overflow = 'hidden';

    // dans pastry on cherche l'élément avec la classe close-popup
    var closePopup = pastry.querySelector('.close-popup');
    disableScroll();
    closePopup.addEventListener('click', function () {
        // on réactive le scroll vertical
        // document.body.style.overflow = 'auto';

        // on cache le popup
        pastry.classList.add('hidden');
        filter.classList.add('hidden');

        // on cache toutes les fleches
        for (var i = 0; i < arrowLeft.length; i++) {
            arrowLeft[i].classList.add('hidden');
        }
        for (var i = 0; i < arrowRight.length; i++) {
            arrowRight[i].classList.add('hidden');
        }

        // on enlève le listener
        closePopup .removeEventListener('click', function () { });
        enableScroll();
    }
    ); 
    // add event listener to the pastry
    arrowLeft.addEventListener('click', function () {
        console.log("click sur le fleche gauche");
        closePopup.click();
        showPastries(findDataId(num-1),num-1,min,max);
    });
    arrowRight.addEventListener('click', function () {
        console.log("click sur le fleche droite");
        closePopup.click();
        showPastries(findDataId(num+1),num+1,min,max);

    });

    arrowLeftMobile.addEventListener('click', function () {
        console.log("click sur le fleche gauche mobile");
        closePopup.click();
        showPastries(findDataId(num-1),num-1,min,max);
    });

    arrowRightMobile.addEventListener('click', function () {
        console.log("click sur le fleche droite mobile");
        closePopup.click();
        showPastries(findDataId(num+1),num+1,min,max);
    });



    
}
//Fonction stop scroll
function disableScroll() {
    document.body.style.overflow = 'hidden';
    document.body.style.overflowX = 'hidden';
    document.body.style.overflowY = 'hidden';
}
  
  //Fonction retour du scroll
function enableScroll() {
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'auto';
    document.body.style.overflowY = 'auto';
}

function findDataId(dataOrder){
    var el = document.querySelector('[data-order="' + dataOrder + '"]');
    // get data-id of the element
    var dataId = el.getAttribute('data-id');
    return dataId;
}